export const allInOneData = {
  "query": "Best universities for MBA in Global",
  "course": "MBA",
  "country": "UK",
  "universities": [
    "Warwick Business School",
    "University of Hull"
  ],
  "table": [
    {
      "university": "Warwick Business School",
      "composite_score": 70,
      "sentiment": 85,
      "tuition_fees": "£40,000",
      "employability": "94%",
      "living_cost": "£12,000 - £18,000",
      "visa_psw": "Available",
      "enhanced_citations": [],
      "data_source": "web_search",
      "last_verified": "2025-08-28",
      "source_badge": "Live Data",
      "live_badge": "Real-time"
    },
    {
      "university": "University of Hull",
      "composite_score": 85,
      "sentiment": 85,
      "tuition_fees": "£18,000",
      "employability": "85%",
      "living_cost": "£12,000 - £18,000",
      "visa_psw": "Available",
      "enhanced_citations": [],
      "data_source": "web_search",
      "last_verified": "2025-08-28",
      "source_badge": "Live Data",
      "live_badge": "Real-time"
    }
  ],
  "chart": {
    "title": "MBA Program Fees Comparison",
    "series": [
      {
        "name": "Warwick Business School",
        "value": 40000
      },
      {
        "name": "University of Hull",
        "value": 18000
      }
    ],
    "x_axis": "University",
    "y_axis": "Fees (£)"
  },
  "evidence_sources": [
    {
      "category": "general",
      "source": "QS World University Rankings",
      "confidence": 0.7,
      "url": "https://www.topuniversities.com/university-rankings/business-masters-rankings/mba/2025",
      "snippet": "QS World University Rankings for MBA programs in the UK 2025, featuring top institutions like Oxford, Cambridge, and London Business School with comprehensive program details.",
      "type": "web_search",
      "domain": "education"
    },
    {
      "category": "general",
      "source": "Financial Times",
      "confidence": 0.7,
      "url": "https://rankings.ft.com/businessschoolrankings/global-mba-ranking-2025",
      "snippet": "Financial Times annual MBA rankings 2025 including UK business schools with employment rates, salary data, and career outcomes for graduates.",
      "type": "web_search",
      "domain": "education"
    },
    {
      "category": "general",
      "source": "Complete University Guide",
      "confidence": 0.7,
      "url": "https://www.thecompleteuniversityguide.co.uk/league-tables/rankings",
      "snippet": "Comprehensive university rankings and guides for MBA programs in the UK, including admission requirements and program comparisons.",
      "type": "web_search",
      "domain": "education"
    }
  ],
  "enhanced_facts": [
    {
      "fact": "The University of Hull and Warwick Business School are both notable options for pursuing an MBA in the UK, each offering unique strengths. Warwick Business School is particularly renowned for its high ranking, robust employment outcomes, and comprehensive program offerings. The University of Hull offers a more budget-friendly option while still providing a quality education. Both institutions cater to intermediate-level professionals seeking to enhance their business acumen and leadership skills.",
      "source": "LLM Analysis",
      "confidence": 85,
      "type": "summary"
    }
  ],
  "cached": false,
  "data_source": "web_search",
  "timestamp": "2025-08-28T18:20:08.992419",
  "source_badge": "Live Data",
  "live_badge": "Real-time",
  "total_sources": 3,
  "llm_sources": 1,
  "bing_sources": 2,
  "metadata": {
    "processing_time": 20.4,
    "sources_used": [
      "OpenAI GPT-4o",
      "DuckDuckGo Web Search"
    ],
    "last_updated": "2025-08-28T18:20:08.991140",
    "model_used": "gpt-4o",
    "web_search_used": true,
    "citation_count": 3,
    "data_source": "web_search",
    "response_quality": "medium",
    "filters_applied": {
      "course": "MBA",
      "country": "Global",
      "universities_count": 2,
      "experience_level": "intermediate",
      "budget_range": "medium"
    }
  }
};
